import _ from 'lodash';

export function isEmpty(value) {
  return _.isEmpty(value);
}

export function hasValue(value) {
  return !_.isNil(value) && !_.isNaN(value);
}

export function getValueOrDefault(object, path, defaultValue) {
  return _.defaultTo(_.get(object, path), defaultValue);
}

export const fromOADate = (oadate) => {
  var date = new Date((oadate - 25569) * 86400000);
  var tz = date.getTimezoneOffset();
  return new Date((oadate - 25569 + tz / (60 * 24)) * 86400000);
};

export function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return Array.from(map, ([key, data]) => ({ key, data }));
}

export function getPath() {
  return window.location.pathname.substring(1);
}

export function findRoot() {
  const path = window.location.pathname.substring(1);
  return path.split('/')[0] === 'sigmaxmtf' ? 'sigmaxmtf' : 'longleat';
}
